import { Typography, Container, Box } from '@mui/material';

export const FooterSurveyLayout = () => {
    return (
        <Box bgcolor="grey.200" py={2}>
            <Container maxWidth="md">
                <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                >
                    Copyright © ComWare 2024.
                </Typography>
            </Container>
        </Box>
    );
};
